export enum NotificationChannel {
	WhatsApp = 'wha',
	Sms = 'sms',
}
